import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { N200 } from '@atlaskit/theme/colors';
var dayNameColor = {
  light: N200,
  dark: N200
};
export var gridsContainerStyle = {
  display: 'inline-block',
  margin: 0,
  textAlign: 'center',
  width: 289,
  marginBottom: 5
};
export var dayNameGridStyle = {
  border: 0,
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)'
};
var dayNameSpacing = {
  padding: '8px 8px',
  minWidth: 40,
  boxSizing: 'border-box'
};
export var dayNameCellStyle = function dayNameCellStyle(mode) {
  return _objectSpread(_objectSpread({
    fontWeight: 700,
    border: 0,
    color: dayNameColor[mode],
    fontSize: 11
  }, dayNameSpacing), {}, {
    textTransform: 'uppercase',
    textAlign: 'center',
    whiteSpace: 'nowrap'
  });
};
export var daysGridStyle = {
  border: 0,
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)'
};